import Enum from '../interfaces/IEnum';

export const RatingsTabs: Enum = {
    enum: {
        EXAMS: 0,
        MERTIS: 1,
        LISTS: 2
    }
};
